import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 1.333v29.334h24V12c0-8-2.667-10.667-10.667-10.667zm18 10.134v2.4H10v-2.4zm0 6.666v2.4H10v-2.4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentFilledSize32Glyph.displayName = 'DocumentFilledSize32Glyph';
